<div class="accessibility-header">   
    <div class="col-12">
        <div class="tab">
       {{ header |translate }} 
        </div>
    </div>
</div>
